"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formHandler_1 = require("../forms/formHandler");
const currentCountry_1 = require("../services/currentCountry");
const contactNumbers_1 = require("../forms/utils/contactNumbers");
const dom_utils_1 = require("../utils/dom-utils");
const currentData = new currentCountry_1.CurrentCountry;
const contactNumbers = new contactNumbers_1.ContactNumbers;
document.addEventListener('DOMContentLoaded', () => {
    disablePaste();
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
        if (form && !form.classList.contains('newsletter-form')) {
            (0, formHandler_1.handleFormSubmission)(form)
                .then(result => {
                console.log(result);
            })
                .catch(error => {
                console.error('An error occurred:', error);
            });
        }
    });
    function disablePaste() {
        const phoneInput = (0, dom_utils_1.elementId)('phoneNumber');
        phoneInput.addEventListener('paste', e => {
            e.preventDefault();
        });
    }
});
